import signupService from './signupService';

class QuizManager {
  createUser = signupService.createUser;

  resetUserPassword = signupService.resetUserPassword;
}

export default new QuizManager();
